import { useState } from "react"
import { observer } from "mobx-react"
import { Button, Table } from "antd"
import { ColumnsType } from "antd/es/table"
import { DeleteOutlined } from "@ant-design/icons"

import { DeleteConfirm } from "@src/app/components/DeleteConfirm"
import { notify } from "@src/app/components/notify"
import { WhitelistAddress } from "@src/app/whitelistStore"
import { WhiteListCollection } from "@src/app/whitelistStore/WhiteListCollection"
import { WithCollection } from "@src/shared/classes/Collection/types"

type Props = WithCollection<WhiteListCollection> & {
  deleteFn: (id: string) => Promise<void>
}
export const WhiteListTable = observer(({ collection, deleteFn }: Props) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)

  const [toDelete, setToDelete] = useState("")

  const showDeleteConfirm = (id: string) => {
    setToDelete(id)

    setOpenDeleteConfirm(true)
  }

  const onDeleteConfirm = () => {
    deleteFn(toDelete).then(() => {
      notify.success("Address has been deleted")

      setOpenDeleteConfirm(false)
    })
  }

  const columns: ColumnsType<WhitelistAddress> = [
    {
      dataIndex: "name",
      title: "Name",
      width: "20%",
    },
    {
      dataIndex: "address",
      title: "Blockchain address",
      width: "20%",
    },
    {
      render: (_, { network }) => network.toUpperCase(),
      title: "Network",
      width: "20%",
    },
    {
      dataIndex: "status",
      title: "Status",
      width: "20%",
    },
    {
      render: (_, { id }) => (
        <Button
          icon={<DeleteOutlined />}
          loading={collection.isLoading}
          onClick={() => showDeleteConfirm(id!)}
          type="text"
        />
      ),
      title: "Action",
    },
  ]

  return (
    <>
      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        pagination={collection.pagination}
      />
      <DeleteConfirm
        cancelText="Cancel"
        isLoading={collection.isLoading}
        okText="Delete Address"
        onCancel={() => setOpenDeleteConfirm(false)}
        onOk={onDeleteConfirm}
        open={openDeleteConfirm}
        text="This action cannot be undone"
        title="Are you sure you want to delete this address?"
      />
    </>
  )
})
